import Avatar from "react-avatar";
import useInbox from "../../InboxTab/InboxContext";
import EmailBody from "./EmailBody";
import EmailBodyHeader from "./EmailBodyHeader";

export default function EmailDetailsWrapper({ message, refreshFunc }) {
  /* ******************** All States ************************* */

  const { messageId, activeLabelTab } = useInbox();

  /* ******************** All Functions ************************* */

  /* ******************** All UseEffects ************************* */

  return (
    <div className={``}>
      {/* Header Row */}
      {activeLabelTab === "inbox" && (
        <div className="d-flex gap-3">
          <div style={{ width: "40px" }}>
            <Avatar
              size="40"
              name={message?.from[0]?.name || ""}
              round={true}
            />
          </div>
          <div className="flex-grow-1 d-flex align-items-center gap-2">
            <EmailBodyHeader message={message} />
          </div>
        </div>
      )}
      {/* Email Body */}
      <div className="d-flex gap-3">
        {activeLabelTab === "inbox" && (
          <div style={{ minWidth: "40px" }}> </div>
        )}
        <div className="flex-grow-1">
          {(messageId || messageId) && (
            <EmailBody message={message} refreshFunc={refreshFunc} />
          )}
        </div>
      </div>
    </div>
  );
}
